module.exports = __webpack_public_path__ + "img/ic-email-ok.9ca3ddea.svg";